import { HttpClient, UsersApi } from '../../../api'
import { Context, throwNotImplemented } from '../../../common'
import { ControlQuestion, ControlQuestionsService } from './controlQuestions'

export class RemoteControlQuestionsService implements ControlQuestionsService {
  private api: UsersApi

  constructor(httpClient: HttpClient) {
    this.api = new UsersApi(httpClient, undefined, '')
  }

  async findAll(ctx: Context): Promise<ControlQuestion[]> {
    const result = await this.api.usersGetControlQuestions(ctx)
    return result.body.items
  }

  find(): Promise<ControlQuestion | undefined> {
    throwNotImplemented('<5cae7359>')
  }
}
